/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React, {useReducer} from 'react'
import {useDrag as useDragReactAria} from 'react-aria'

const MOVE = 'move'
const COPY = 'copy'
const LINK = 'link'
const CANCEL = 'cancel'

const TEXT_PLAIN_MIME = 'text/plain'
const TEXT_HTML_MIME = 'text/html'
const FK_OBJECT_TYPE = 'fk/object'

type Action = {type: 'move'} | {type: 'copy'} | {type: 'link'} | {type: 'cancel'}
type State = {
  moved: boolean
  copied: boolean
  linked: boolean
  canceled: boolean
}

export type DragData = {
  [TEXT_PLAIN_MIME]: string
  [TEXT_HTML_MIME]: string
  [FK_OBJECT_TYPE]: string
}

const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case MOVE:
      return {...state, moved: true}
    case COPY:
      return {...state, copied: true}
    case LINK:
      return {...state, linked: true}
    case CANCEL:
      return {...state, canceled: true}
    default:
      return state
  }
}

const initialState: State = {moved: false, copied: false, linked: false, canceled: false}

const useDrag = (previewRef: React.MutableRefObject<null>, dragData: DragData) => {
  const [dragState, dispatch] = useReducer(reducer, initialState)
  const {dragProps, isDragging} = useDragReactAria({
    preview: previewRef,
    getItems() {
      return [dragData]
    },
    onDragEnd(e) {
      if (e.dropOperation === MOVE) {
        dispatch({type: MOVE})
      }
      if (e.dropOperation === COPY) {
        dispatch({type: COPY})
      }
      if (e.dropOperation === LINK) {
        dispatch({type: LINK})
      }
      if (e.dropOperation === CANCEL) {
        dispatch({type: CANCEL})
      }
    },
    getAllowedDropOperations() {
      return [MOVE, COPY, CANCEL, LINK]
    }
  })

  return {
    dragState,
    dragProps,
    isDragging
  }
}

export default useDrag
